export default __webpack_public_path__ + "static/media/sticker-e.fb047efb.png";